export default {
    opened: 'modal-opened',
    closed: 'modal-closed',
    close: 'close-modal',
    toggle: 'toggle-modal'
};
